var map = {
	"./1.jpg": 7465,
	"./2.jpg": 711,
	"./3.jpg": 7043,
	"./4.jpg": 4020,
	"./5.jpg": 9650,
	"./6.jpg": 7987,
	"./7.jpg": 150,
	"./8.jpg": 1255,
	"./9.jpg": 4160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2370;